import React from 'react';
import { FaCode } from 'react-icons/fa';

import {PaperDarkBG } from "../kits/DesignKit";
import BlogList from './BlogList';


function SectionBlog() {
  return (
    <PaperDarkBG>
      {/* Die oben definierte Section */}
      <section className="py-20 sm:py-16 md:py-20">
        <div className="container mx-auto text-center px-10">
          <h1 className="text-sm sm:text-lg font-mono mb-4">
            Lern Studio <span className='text-orange-300'>+</span>  <span className="text-white bg-gray-950 "> Echte Lösungen <br /> </span> um mehr zu wissen <span className=" inline-Block text-center"></span>
          </h1>

          <p className="italic text-xs font-mono sm:text-xs md:text-xs">
            by Denis Bitter
          </p>
        </div>
      </section>
    </PaperDarkBG>
  );
}

export default SectionBlog;